import { HStack, View } from "@gluestack-ui/themed";

import { CustomHeaderProps, HeaderStyleEnum } from "./types";
import { Icon } from "@repo/core/components/core/Icon";
import { Pressable } from "react-native";
import { useDimensions } from "@repo/core/hooks/useDimensions";
import { HeaderStyle } from "@repo/core/components/layout/CustomHeader/utils";
import { Text } from "@repo/core/components/core/Text";

export const CustomHeader = ({
  title,
  onBackPress,
  rightIcon,
  rightWebLabel,
  headerStyle = HeaderStyleEnum.default,
  bg,
  rightIconVariant = "solid",
  rightIconSize = 16,
  onPressRightIcon,
  showBackButtonOnWeb
}: CustomHeaderProps) => {
  const { isMobile } = useDimensions();
  const style = HeaderStyle[headerStyle];

  return (
    <HStack
      alignItems="center"
      px="$6"
      pt="$4"
      pb="$2"
      position="relative"
      bg={bg || style.backgroundColor}
    >
      <View flex={0.1}>
        {onBackPress && (isMobile || showBackButtonOnWeb) ? (
          <Pressable hitSlop={16} onPress={onBackPress} bg="transparent">
            <HStack
              gap="$2"
              alignItems="center"
              bg="transparent"
              justifyContent="flex-start"
            >
              <Icon
                name="arrow-left"
                variant="solid"
                size={16}
                color={style.leftColor}
                strokeWidth={2}
              />
              {!isMobile ? (
                <Text color={style.leftColor} fontSize="$sm" fontWeight={600}>
                  Voltar
                </Text>
              ) : null}
            </HStack>
          </Pressable>
        ) : null}
      </View>
      <View flex={1} alignItems="center" justifyContent="center">
        <Text fontSize="$lg" fontWeight={500} color={style.titleColor}>
          {title}
        </Text>
      </View>

      <View flex={0.1}>
        {rightIcon && rightWebLabel ? (
          <Pressable hitSlop={16} onPress={onPressRightIcon}>
            <HStack gap="$2" alignItems="center" justifyContent="flex-end">
              <Icon
                name={rightIcon}
                variant={rightIconVariant}
                size={rightIconSize}
                color={style.rightColor}
              />
              {!isMobile ? (
                <Text color={style.rightColor} fontSize="$sm" fontWeight={600}>
                  {rightWebLabel}
                </Text>
              ) : null}
            </HStack>
          </Pressable>
        ) : null}
      </View>
    </HStack>
  );
};
